export const Loader =()=>{
    return <span className="spinner"></span>
}